export type Priority = 'urgence' | 'action' | 'service' | 'activite' | 'statut' | 'suggestion'

export interface ForYouItem {
  id: string
  priority: Priority
  eyebrow: string
  title: string
  detail: string
  cta: string
  to: string
}

export interface EspaceService {
  id: string
  name: string
  context: string
  icon: 'card' | 'trash' | 'ball' | 'request' | 'booking' | 'invoice' | 'bell' | 'pet'
  to: string
}

/** Visuels tires du site de la Ville. */
const IMG_PUBLIC_WORKS = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/09/Public-Works-400x250.png'
const IMG_TOWN_HALL = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/08/Town-Hall-Notice-400x250.png'
const IMG_POOL = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/08/Pool-Notice-400x250.png'
const IMG_PARK = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/07/Park2.jpg'
const IMG_TOWN = 'https://town.bonnyville.ab.ca/wp-content/uploads/2024/07/town10.jpg'

export const citizenFirstName = 'Bryon'

export const forYouItems: ForYouItem[] = [
  {
    id: 'ebullition',
    priority: 'urgence',
    eyebrow: 'Boil water advisory',
    title: 'Your address at 5108 - 46 Street is affected.',
    detail: 'In effect since today, 2:30 p.m.',
    cta: 'View the instructions',
    to: '/notifications',
  },
  {
    id: 'collecte',
    priority: 'service',
    eyebrow: 'Collections',
    title: 'Collection tomorrow',
    detail: 'Recycling · Yard waste · put out tonight',
    cta: 'View my collections',
    to: '/my-collections',
  },
  {
    id: 'natation',
    priority: 'activite',
    eyebrow: 'Recreation',
    title: 'Emma’s swim lesson',
    detail: 'Saturday · 10 a.m. · Bonnyville Swimming Pool',
    cta: 'View the activity',
    to: '/my-recreation',
  },
  {
    id: 'demande',
    priority: 'statut',
    eyebrow: 'Request #REQ-2841',
    title: 'Pothole — new status: In progress',
    detail: '5108 - 46 Street · updated August 28',
    cta: 'Track my request',
    to: '/my-requests/req-2841',
  },
  {
    id: 'milo',
    priority: 'action',
    eyebrow: 'My pet',
    title: 'Vaccination reminder for Milo',
    detail: 'Due October 14 · shared by Vet&Co',
    cta: 'View Milo',
    to: '/my-pets/milo',
  },
  {
    id: 'pickleball',
    priority: 'action',
    eyebrow: 'Registration',
    title: 'Pickleball',
    detail: 'Registration opens Monday at 9 a.m.',
    cta: 'Notify me',
    to: '/my-recreation',
  },
]

export const espaceServices: EspaceService[] = [
  {
    id: 'carte',
    name: 'Digital card',
    context: 'Active · Swimming Pool and recreation access',
    icon: 'card',
    to: '/my-card',
  },
  { id: 'collectes', name: 'Collections', context: 'Next collection tomorrow', icon: 'trash', to: '/my-collections' },
  { id: 'loisirs', name: 'Recreation', context: '2 family activities this week', icon: 'ball', to: '/my-recreation' },
  { id: 'demandes', name: 'My requests', context: '1 request in progress', icon: 'request', to: '/my-requests' },
  { id: 'reservations', name: 'Bookings', context: 'Halls and sports facilities', icon: 'booking', to: '/my-recreation' },
  { id: 'factures', name: 'Invoices', context: '1 invoice to pay', icon: 'invoice', to: '/my-profile' },
  { id: 'avis', name: 'Notifications', context: '3 unread notices', icon: 'bell', to: '/notifications' },
  { id: 'animaux', name: 'My pets', context: 'Milo · licence active', icon: 'pet', to: '/my-pets' },
]

export const discoverItems = [
  {
    id: 'equipement',
    title: 'Discover hall and facility bookings',
    detail: 'Gymnasiums, community halls and sports facilities, booked online.',
    to: '/my-recreation',
  },
  {
    id: 'rappels',
    title: 'Get collection reminders',
    detail: 'A notice the day before, on the channel of your choice.',
    to: '/notifications/settings',
  },
]

export interface EspaceNavItem {
  id: string
  label: string
  icon: 'home' | 'card' | 'profile' | 'bell' | 'trash' | 'request'
  to: string
}

export const espaceNav: EspaceNavItem[] = [
  { id: 'accueil', label: 'Home', icon: 'home', to: '/my-dashboard' },
  { id: 'carte', label: 'My Card', icon: 'card', to: '/my-card' },
  { id: 'profil', label: 'My Profile', icon: 'profile', to: '/my-profile' },
  { id: 'avis', label: 'Notifications', icon: 'bell', to: '/notifications' },
  { id: 'collectes', label: 'My Collections', icon: 'trash', to: '/my-collections' },
  { id: 'requete', label: 'Request', icon: 'request', to: '/my-requests' },
]

export interface LocalNewsItem {
  id: string
  date: string
  category: string
  title: string
  image: string
  to?: string
}

export const localNews: LocalNewsItem[] = [
  {
    id: 'collection-delay',
    date: 'September 8, 2026',
    category: 'Collection',
    title: 'Recycling collection delayed in Zone 2',
    image: IMG_PUBLIC_WORKS,
    to: '/my-collections',
  },
  {
    id: 'date-night',
    date: 'September 8, 2026',
    category: 'Event',
    title: 'Date Night in the Park with Clayton Bellamy',
    image: IMG_PARK,
  },
  {
    id: 'back-to-school',
    date: 'September 2, 2026',
    category: 'Public notice',
    title: 'Back-to-school reminder: keep drop-off areas safe',
    image: IMG_TOWN_HALL,
  },
]

export interface NearbyEvent {
  id: string
  date: string
  time?: string
  title: string
  image: string
}

export const nearbyEvents: NearbyEvent[] = [
  {
    id: 'date-night',
    date: 'Fri. Sept. 11',
    time: '5:30 to 7:30 p.m.',
    title: 'Date Night in the Park with Clayton Bellamy',
    image: IMG_PARK,
  },
  {
    id: 'book-club',
    date: 'Wed. Sept. 16',
    time: '6:30 p.m.',
    title: 'B.Y.O. Book Club',
    image: IMG_TOWN_HALL,
  },
  {
    id: 'strays',
    date: 'Sat. Oct. 3',
    time: '6 to 9 p.m.',
    title: 'Stand Up for Strays Comedy Night',
    image: IMG_TOWN,
  },
]

export interface UsefulService {
  id: string
  name: string
  open: boolean
  hours: string
  image: string
}

export const usefulServices: UsefulService[] = [
  {
    id: 'ville',
    name: 'Bonnyville Town Office',
    open: false,
    hours: 'Opens Monday 8:30 a.m.',
    image: IMG_TOWN_HALL,
  },
  {
    id: 'biblio',
    name: 'Bonnyville Municipal Library',
    open: true,
    hours: 'Closes at 8 p.m.',
    image: IMG_TOWN,
  },
  {
    id: 'aquatique',
    name: 'Bonnyville Swimming Pool',
    open: false,
    hours: 'Closed for annual maintenance',
    image: IMG_POOL,
  },
  {
    id: 'ecocentre',
    name: 'Bonnyville Transfer Station',
    open: false,
    hours: 'Opens Saturday 9 a.m.',
    image: IMG_PUBLIC_WORKS,
  },
  {
    id: 'multigenerationnel',
    name: 'Bonnyville Seniors Drop-In Centre',
    open: false,
    hours: 'Opens Monday 8 a.m.',
    image: IMG_PARK,
  },
]

export const appBenefits = [
  { id: 'carte', label: 'Your card, always with you', icon: 'card' },
  { id: 'alertes', label: 'Get only what concerns you', icon: 'bell' },
  { id: 'lieu', label: 'Services that follow where you are', icon: 'pin' },
  { id: 'photo', label: 'Report a problem in seconds', icon: 'camera' },
  { id: 'acces', label: 'Get into your activities and facilities', icon: 'key' },
] as const

export const mobileItems = [
  { id: 'collecte', eyebrow: 'Collection tomorrow', detail: 'Recycling' },
  { id: 'natation', eyebrow: 'Emma’s swim lesson', detail: 'Saturday · 10 a.m.' },
  { id: 'demande', eyebrow: 'Request #2841', detail: 'In progress' },
]
